import statistics from './src/statistics';
import business from './src/business';

export default {
  statistics,
  business
};
